import PinField from './PinField.component';

export default PinField;